import { render, staticRenderFns } from "./CourseDetailStep.vue?vue&type=template&id=1339e564&scoped=true"
import script from "./CourseDetailStep.vue?vue&type=script&lang=js"
export * from "./CourseDetailStep.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailStep.vue?vue&type=style&index=0&id=1339e564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339e564",
  null
  
)

export default component.exports